
import Vue from "vue";

export interface ISidebarKeyValueRow {
	label:string;
	value:string | number | null | undefined;
	href?:string;
	right?:boolean;
	hideIfEmpty?:boolean;
	warning?:boolean;
	badge?:"success" | "danger" | "neutral";
}

export default Vue.extend({
	props: {
		rows: {
			type: Array as () => ISidebarKeyValueRow[],
			required: true
		}
	},
	computed: {
		visibleRows():ISidebarKeyValueRow[] {
			return this.rows.filter(r=>!(r.hideIfEmpty && this.isEmpty(r)));
		}
	},
	methods: {
		isEmpty(row:ISidebarKeyValueRow):boolean {
			return row.value === null || row.value === undefined || row.value === "";
		}
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
